import type { ProductData } from '@sofa-platform/types'

import { FILTER_ATTRIBUTE_HEADERCODE } from '../constants'

export function getProductFilterAttributeValue(
  product: ProductData,
  attributeKey: keyof typeof FILTER_ATTRIBUTE_HEADERCODE,
) {
  return product.content.filterAttribute?.find(
    (attribute) => attribute.headerCode === FILTER_ATTRIBUTE_HEADERCODE[attributeKey],
  )?.value
}
